import React, { useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import { useNavigate } from 'react-router-dom';
import { Link ,} from 'react-router-dom';
import WithdrawServices from '../services/WithdrawServices';
import ReactPaginate from "react-paginate";
import Modal from 'react-modal';

import * as XLSX from 'xlsx';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
Modal.setAppElement('#root');
function RejectedWithdrawalList() {
  const { data, error, isLoading, run } = useAsync(WithdrawServices.getRejectedWithdrawList);
  const navigate = useNavigate();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [planFilter, setPlanFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
   
  // const handleViewDetails = (user) => {
  //   setSelectedUser(user);
  //   setIsModalOpen(true);
  // };


  const handleViewDetails = (withdraw) => {
    const id = withdraw._id || withdraw.id;
    navigate(`/view-withdrawl-detail/${id}`);
  };
  const handleEditDetails = (provider) => {
    navigate("/providers/edit", {
      state: {
        provider: provider,
      },
    });
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

 const filteredUsers =
  data?.data?.filter((withdraw) => {
    const search = searchQuery.toLowerCase().trim();

    const fullName = `${withdraw?.user_id?.firstName || ""} ${
      withdraw?.user_id?.lastName || ""
    }`
      .toLowerCase()
      .trim();

    return (
      fullName.includes(search) ||
      withdraw?.payment_method?.toLowerCase().includes(search) ||
      withdraw?.transaction_id?.toLowerCase().includes(search) ||
      withdraw?.status?.toLowerCase().includes(search) ||
      withdraw?.upi_id?.toLowerCase().includes(search) ||
      withdraw?.amount?.toString().includes(search)
    );
  }) || [];

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const generateExcel = () => {
    const filteredData = currentUsers?.map((user, index) => ({
      SNo: index + 1,
      'Customer Name': user?.user_id?.name || user?.upi_name || user?.account_holder_name || "N/A",
      'Mobile': user?.user_id?.mobileNo || "N/A",
      'Payment Method': user?.payment_method || "N/A",
      'Amount': user?.amount || "N/A",
      'Transaction ID': user?.transaction_id || "N/A",
      'Status': user?.status || "Rejected",
      'Date': user?.createdAt ? new Date(user.createdAt).toLocaleDateString() : "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Rejected Withdrawals');
    XLSX.writeFile(wb, 'rejected_withdrawals.xlsx');
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handlePlanChange = (e) => {
    setPlanFilter(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">Rejected Withdrawal List <span className="badge bg-orange">{filteredUsers?.length || 0}</span></h5>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Rejected Withdrawal List
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center">
          {/* <Link className="round-add-btn" to="/add-provider">
            <img src="img/plus.svg" alt="Add Commission" />
          </Link> */}
          <div className="pe-1 mb-xl-0">
            <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
              <button className="excel-btn" onClick={generateExcel}>
                <img src="img/excel.svg" alt="Download Excel" />
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-box px-0 user-manager">
        <div className="Tablesearch_design">
          <div className='row'>
            <div className='col-md-6 col-sm-6'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div className='w-100'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search by Name, Mobile, Payment Method, Transaction ID"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className='form-control'
                  />
                </div>
                <div>
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-6 col-md-6">
              <div className="input-field">
                <select className="form-select selectcustum" value={planFilter} onChange={handlePlanChange}>
                  <option value="">Filter</option>
                  <option value="hasPlan">Plan Holder</option>
                  <option value="noPlan">No Plan</option>
                </select>
              </div>
            </div> */}
          </div>
        </div>

        <div className="container-box-inner table-reponsive-tabe">
          <table id="example" className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Customer Name</th>
                <th>Mobile</th>
                <th>Payment Method</th>
                <th>Amount</th>
                <th>Transaction ID</th>
                <th>Status</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers?.map((withdraw, index) => (
                <tr key={withdraw?.id || index}>
                  <td>{index + 1}</td>
                  <td>
                    {withdraw?.user_id?.firstName || ""}{" "}
                    {withdraw?.user_id?.lastName || ""}
                  </td>
                  <td>
                    {withdraw?.user_id?.mobileNo || "N/A"}
                  </td>
                  <td>
                    {withdraw?.payment_method || "N/A"}
                  </td>
                  <td>
                    ₹{withdraw?.amount || 0}
                  </td>
                  <td>
                    {withdraw?.transaction_id || "N/A"}
                  </td>
                  <td>
                    <span className="badge bg-danger">
                      {withdraw?.status || "Rejected"}
                    </span>
                  </td>
                  <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            <li>
                              <li>
                                <button className="approve" style={{ backgroundColor: '#60B930' }} onClick={() => handleViewDetails(withdraw)}>  <FaRegEye /> View</button>
                              </li>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredUsers?.length || 0) / usersPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>

      {/* <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Withdraw Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewPasses user={selectedUser} closeModal={closeModal} />
      </Modal> */}
    </div>
  );
}

export default RejectedWithdrawalList;